module.exports = __webpack_public_path__ + "static/media/mano-banner.d1610678.svg";